import styles from "./Feature.module.css";
function Feature({ heading, description, path, svg }) {
  return (
    <div className={styles["feature-container"]}>
      <div className={styles["heading-container"]}>
        {svg}
        <h3>{heading}</h3>
      </div>
      <p className={styles["feature-description"]}>{description}</p>
    </div>
  );
}

export default Feature;
